<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="model.accompaniments"
      class="elevation-1 mb-7"
      no-data-text="No hay registros agregados..."
      :items-per-page="20"      
    >
      <template v-slot:top v-if="edit">
        <v-toolbar flat>
          <v-toolbar-title>Acompañamientos</v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Dialog add supervisor -->
          <v-dialog v-model="dialogAdd" max-width="700px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                Agregar
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ titleDialog }} Acompañamiento</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form ref="form" v-model="formAdd">
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="modelAccompaniment.oriented_name"
                          label="NOMBRE DEL COLABORADOR"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          v-model="modelAccompaniment.detailed_fortress"
                          label="FORTALEZAS DETALLADAS"
                          required
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          v-model="
                            modelAccompaniment.detailed_improvement_aspects
                          "
                          label="ASPECTOS DE MEJORAS DETALLADOS"
                          required
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <evidences-form
                          :model="modelAccompaniment"
                          :charge="charge"
                          :rules="rules"
                          :edit="true"
                        ></evidences-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancelar
                </v-btn>
                <v-btn color="blue darken-1" text @click="save">
                  {{ titleDialog }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Dialog delete supervisor -->
          <v-dialog v-model="dialogDelete" max-width="520px">
            <v-card>
              <v-card-title class="headline"
                >Seguro que desea eliminar esta actividad?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancelar</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteConfirm"
                  >Aceptar</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.documents`]="item">
        <span v-if="edit">
          {{ item.item.evidences ? item.item.evidences.length : 0 }}
          Evidencia(s)
        </span>
        <v-btn
          color="blue"
          class="white--text mr-2"
          small
          rounded
          v-else
          v-for="(value, index) in item.item.evidences"
          v-bind:key="index"
          target="_blank"
          :href="value.url"
        >
          Evidencia {{ index + 1 }}
        </v-btn>
      </template>
      <template v-slot:[`item.actions`]="item">
        <v-tooltip bottom v-if="edit">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="red"
              v-bind="attrs"
              v-on="on"
              @click="deleteAccompaniment(item.item)"
            >
              <v-icon dark> mdi-delete </v-icon>
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
        <span v-else>N/A</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { SET_ALERT } from "@/store/alert";
import EvidencesForm from "@/components/report/create/Evidences";
export default {
  name: "Accompaniments",
  props: {
    model: {
      type: Object,
      required: true,
    },
    charge: {
      required: true,
    },
    rules: {
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    EvidencesForm,
  },
  data: () => ({
    current: null,
    formAdd: true,
    dialogAdd: false,
    editedIndex: -1,
    dialogDelete: false,
    modelAccompaniment: {
      oriented_name: "",
      detailed_fortress: "",
      detailed_improvement_aspects: "",
      evidences: [],
    },
    headers: [
      { text: "NOMBRE ORIENTADO", value: "oriented_name", sortable: false },
      {
        text: "FORTALEZAS DETALLADAS",
        value: "detailed_fortress",
        sortable: false,
      },
      {
        text: "ASPECTOS DE MEJORAS",
        value: "detailed_improvement_aspects",
        sortable: false,
      },
      { text: "EVIDENCIAS", value: "documents", sortable: false },
      { text: "ACCIÓN", value: "actions", sortable: false },
    ],
  }),
  computed: {
    titleDialog() {
      return this.current ? "Editar" : "Agregar";
    },
  },
  methods: {
    deleteAccompaniment(item) {
      this.editedIndex = this.model.accompaniments.indexOf(item);
      this.dialogDelete = true;
    },
    deleteConfirm() {
      this.model.accompaniments.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    close() {
      this.dialogAdd = false;
      this.$nextTick(() => {
        this.modelAccompaniment = {
          oriented_name: "",
          detailed_fortress: "",
          detailed_improvement_aspects: "",
          evidences: [],
        };
        this.editedIndex = -1;
        this.$refs.form.resetValidation();
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.current = null;
        this.editedIndex = -1;
      });
    },
    save() {
      //Validate inputs
      if (
        this.modelAccompaniment.oriented_name == "" ||
        this.modelAccompaniment.detailed_fortress == "" ||
        this.modelAccompaniment.detailed_improvement_aspects == ""
      ) {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }
      this.model.accompaniments.push(this.modelAccompaniment);
      this.close();
    },
  },
};
</script>

<style>
</style>